import {Component, inject, Input} from '@angular/core';
import {UntypedFormGroup} from '@angular/forms';
import {availableCountryCodes, CountryCode} from '@em/shared/util-types';
import {PartnerService} from '@em/shared/white-label';
import {map, Observable} from 'rxjs';

@Component({
  selector: 'em-change-country',
  templateUrl: './change-country.component.html',
  styleUrls: ['./change-country.component.scss'],
  standalone: false,
})
export class ChangeCountryComponent {
  @Input() form?: UntypedFormGroup;

  private readonly _partner = inject(PartnerService);

  readonly countries$: Observable<readonly CountryCode[]> =
    this._partner.observable().pipe(
      map((partner) => partner.restrictedCountryCodes() ?? availableCountryCodes),
    );
}
